const TransnistriaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112579)">
      <path
        d="M39.311 14.7826C37.016 6.26727 29.2405 0 20 0C10.7594 0 2.98396 6.26727 0.688965 14.7826L20 15.6522L39.311 14.7826Z"
        fill="#A2001D"
      />
      <path
        d="M0.688965 25.2182C2.98396 33.7335 10.7594 40.0008 20 40.0008C29.2405 40.0008 37.016 33.7336 39.311 25.2182L20 24.3486L0.688965 25.2182Z"
        fill="#A2001D"
      />
      <path
        d="M39.311 14.7832H0.688984C0.240625 16.4467 0 18.1954 0 20.0006C0 21.8059 0.240625 23.5545 0.688984 25.218H39.3111C39.7594 23.5545 40 21.8059 40 20.0006C40 18.1954 39.7594 16.4467 39.311 14.7832Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112579">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TransnistriaSvg;
